import { useEffect, useState } from "react";
import { Icon, InputText, Stack } from "@bookingcom/bui-react";
import { MagnifyingGlassIcon } from "@bookingcom/bui-assets-react/streamline";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { useDebounce } from "../../hooks/useDebounce";
import styles from "./AirlinePicker.module.css";

type AirlinePickerInputProps = {
  setQuery: (query: string) => void;
};

export const AirlinePickerInput = ({ setQuery }: AirlinePickerInputProps) => {
  const i18n = useI18n();
  const [input, setInput] = useState("");
  const query = useDebounce(input, 300);

  useEffect(() => setQuery(query), [query, setQuery]);

  return (
    <Stack mixin={{ paddingBlockStart: 4, paddingBlockEnd: 3, paddingInlineStart: 4, paddingInlineEnd: 4 }}>
      <InputText
        className={styles.airlinePickerInput}
        name="search"
        placeholder={i18n.trans(t("flights_airline_portal_superuser_overview_report_dropdown_placeholder"))}
        startIcon={<Icon svg={MagnifyingGlassIcon} />}
        value={input}
        onChange={({ value }) => setInput(value)}
      />
    </Stack>
  );
};
